import type { AssembledContract, ProjectBrief, StandardId } from "./types";
import { assembleFidic2017 } from "./fidic-2017";
import { assembleAia } from "./aia-a101";
import { assembleB101 } from "./aia-b101";

export const STANDARDS: { id: StandardId; label: string; short: string }[] = [
  { id: "FIDIC_REDBOOK_2017", label: "FIDIC Red Book — Conditions of Contract for Construction, Second Edition 2017", short: "FIDIC 2017" },
  { id: "AIA_A101_2017", label: "AIA A101-2017 — Owner–Contractor Agreement (Stipulated Sum)", short: "AIA A101" },
  { id: "AIA_B101_2017", label: "AIA B101-2017 — Owner–Architect Agreement (Design Services)", short: "AIA B101" },
];

export function assemble(brief: ProjectBrief): AssembledContract {
  switch (brief.standard) {
    case "AIA_A101_2017":
      return assembleAia(brief);
    case "AIA_B101_2017":
      return assembleB101(brief);
    case "FIDIC_REDBOOK_2017":
    case "FIDIC_REDBOOK_1999":
    default:
      return assembleFidic2017(brief);
  }
}
